module.exports = __webpack_public_path__ + "static/media/SeguroNFRBlanco.b3d6f34d.png";